module.exports = __webpack_public_path__ + "img/ilustracion_fondo_con_margen-min.36c81f6c.png";